import { c as _c } from "react/compiler-runtime";
import { TechLogoImage } from '@/lib/techLogos';

/**
 * Shared tech-logo pill rendered across project surfaces (the /projects grid
 * card, the home featured list, and the project detail page). The visual
 * variants differ enough — padding, text size/color, hover, dark states, the
 * featured list's `relative z-10` stacking — that each callsite passes its exact
 * `className` (button) and `logoClassName`/`logoSize` (logo) so the rendered
 * output stays byte-identical to the originals. The shared part is the
 * structure: a <button> wrapping <TechLogoImage> + a <span> label.
 */
interface TechChipProps {
  label: string;
  /** Value passed to TechLogoImage's `name` (callers may pass a logoKey). */
  logoName: string;
  logoSize: number;
  logoClassName: string;
  className: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
export function TechChip(t0) {
  const $ = _c(12);
  const {
    label,
    logoName,
    logoSize,
    logoClassName,
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] !== logoClassName || $[1] !== logoName || $[2] !== logoSize) {
    t1 = <TechLogoImage name={logoName} size={logoSize} className={logoClassName} />;
    $[0] = logoClassName;
    $[1] = logoName;
    $[2] = logoSize;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== label) {
    t2 = <span>{label}</span>;
    $[4] = label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== className || $[7] !== label || $[8] !== onClick || $[9] !== t1 || $[10] !== t2) {
    t3 = <button type="button" className={className} title={label} onClick={onClick}>{t1}{t2}</button>;
    $[6] = className;
    $[7] = label;
    $[8] = onClick;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}